export default "__VITE_ASSET__BiWF4sQm__"